import { version } from '../../../../package';

export default {
  online: (typeof navigator.onLine !== 'undefined') ? navigator.onLine : true,
  sidebarOpen: false,
  version,
  authenticated: false,
  profileComplete: null,
  loading: true,
};
